import CallToAction, { CallToActionProps } from './CallToAction';

export default CallToAction;

export type { CallToActionProps };
